import { render, staticRenderFns } from "./myself.vue?vue&type=template&id=0af561d1&scoped=true"
import script from "./myself.vue?vue&type=script&lang=js"
export * from "./myself.vue?vue&type=script&lang=js"
import style0 from "./myself.vue?vue&type=style&index=0&id=0af561d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af561d1",
  null
  
)

export default component.exports